import { get, post } from 'services/http';

const getDiscoveryExamples = () => get('/examples', { addKgId: true });

const generateDiscoveryExamples = kgId =>
  post(`/studio/api/knowledge-graphs/${encodeURIComponent(kgId)}/discovery`, undefined);

export default { getDiscoveryExamples, generateDiscoveryExamples };
